import { Reducer } from 'redux';

import * as types from './subscription.types';
import * as constants from './subscription.constants';
import { isActionOfType } from '../../../utils/action.utils';

const initialState: types.ISubscriptionPageState = {
  setupSession: null,
  billingInfo: null,
};

const setupSessionReducer: Reducer<types.ISubscriptionPageState['setupSession'], types.ISubscriptionPageAction> = (
  state = initialState.setupSession,
  action,
) => {
  if (isActionOfType<types.IStoreSetupSession>(action, constants.STORE_SETUP_SESSION)) {
    return action.payload;
  }
  if (isActionOfType<types.IClearSetupSession>(action, constants.CLEAR_SETUP_SESSION)) {
    return initialState.setupSession;
  }
  return state;
};

const billingInfoReducer: Reducer<types.ISubscriptionPageState['billingInfo'], types.ISubscriptionPageAction> = (
  state = initialState.billingInfo,
  action,
) => {
  if (isActionOfType<types.IStoreBillingInfo>(action, constants.STORE_BILLING_INFO)) {
    return action.payload;
  }
  if (isActionOfType<types.IClearBillingInfo>(action, constants.CLEAR_BILLING_INFO)) {
    return initialState.billingInfo;
  }
  return state;
};

export const subscriptionPageReducer: Reducer<types.ISubscriptionPageState, types.ISubscriptionPageAction> = (
  state = initialState,
  action,
) => {
  return {
    setupSession: setupSessionReducer(state.setupSession, action),
    billingInfo: billingInfoReducer(state.billingInfo, action),
  };
};
